
/*global define */
define('jsx!components/react-ad/main',['jquery', 'underscore', 'react'], function($, _, React) {
    'use strict';

    var PureRenderMixin = React.addons.PureRenderMixin;
    var Ad = React.createClass({displayName: "Ad",
        mixins: [PureRenderMixin],
        getDefaultProps: function() {
            return {
                lazyload: true,
                refresh: false,
            };
        },
        componentDidMount: function() {
            var name = this.props.name;
            var apntag = window.apntag = (window.apntag || {});
            apntag.anq = apntag.anq || [];
            apntag.anq.push(function() {
                var tag = apntag.requests.tags['ad-' + name];
                if ((tag && tag.empty) || !tag) {
                    return $('#ad-' + name).hide();
                }
                apntag.showTag('ad-' + name);
            });
        },
        render: function() {
            return (
                React.createElement("div", {
                    id: 'ad-' + this.props.name, 
                    className: 'ad appnexus ' + this.props.name, 
                    "data-name": this.props.name, 
                    "data-id": this.props.id, 
                    "data-lazyload": this.props.lazyload, 
                    "data-refresh": this.props.refresh
                }, 
                    React.createElement("div", {id: 'ad-' + this.props.name + '-button'}), 
                    React.createElement("div", {id: 'ad-' + this.props.name + '-container'})
                )
            );
        }
    });

    return Ad;
});

